// 首页与导航统一入口：语言字段在同目录维护，逻辑与显示映射在此集中管理。
import * as simplified from "./zh-CN.js";
import * as traditional from "./zh-HK.js";
import * as english from "./en-US.js";
export const zhCN = simplified.messages;
export const zhHK = traditional.messages;
export const enUS = english.messages;

// 分区导出保留原有接口，词条只在语言文件中保存一份。
export const mobileZhCN = simplified.mobile;
export const mobileZhHK = traditional.mobile;
export const mobileEnUS = english.mobile;
export const pcHomeZhCN = simplified.desktop;
export const pcHomeZhHK = traditional.desktop;
export const pcHomeEnUS = english.desktop;
export const pcCshomeZhCN = simplified.testHome;
export const pcCshomeZhHK = traditional.testHome;
export const pcCshomeEnUS = english.testHome;
export const pcFooterZhCN = simplified.footer;
export const pcFooterZhHK = traditional.footer;
export const pcFooterEnUS = english.footer;

export const shortcutLabelKeys = Object.freeze({
  供需: "pcHome.shortcut.supplyDemand",
  供应: "pcHome.shortcut.supply",
  需求: "pcHome.shortcut.demand",
  自营: "pcHome.shortcut.selfOperated",
  精选: "pcHome.shortcut.featured",
  竞标: "pcHome.shortcut.bidding",
  百科: "pcHome.shortcut.wiki",
  芯片百科: "pcHome.shortcut.wiki",
  价格指数: "pcHome.shortcut.marketIndex",
  检测溯源: "pcHome.shortcut.traceability",
  培训认证: "pcHome.shortcut.training",
  品牌: "pcHome.shortcut.brands",
});
